import { createParser } from 'nuqs'

export const parseAsTime = createParser({
	parse(queryValue) {
		return queryValue?.replace('-', ':')
	},
	serialize(value) {
		return value?.replace(':', '-')
	},
})
